// extracted by mini-css-extract-plugin
export default {"pagination_btn":"styles_pagination_btn__ntCSD","active":"styles_active__VEoGp","totalPage_btn":"styles_totalPage_btn__et+ww","ellipsis":"styles_ellipsis__Igm2v"};